import { Token } from '@lumino/coreutils';
/**
 * The token for the settings service.
 */
export const ISettings = new Token('@jupyterlite/settings:ISettings');
//# sourceMappingURL=tokens.js.map